import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import ConfirmationModal from '../../../../common/modal/ConfirmationModal';
import { deleteItinerarySchedule } from '../../../../../actions';

class TemplateDeleteButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
    };
  }

  onClickDelete = () => {
    const { dispatchDeleteItinerarySchedule, itineraryId } = this.props;
    dispatchDeleteItinerarySchedule({ itineraryId });
  };

  onClickShowModal = () => this.setState({ showModal: true });

  onClickCancel = () => this.setState({ showModal: false });

  render() {
    const { showModal } = this.state;

    const warningModal = (
      <ConfirmationModal
        show={showModal}
        onClickConfirm={this.onClickDelete}
        onClickCancel={this.onClickCancel}
      />
    );

    const deleteButton = (
      <Button color="danger" onClick={this.onClickShowModal}>
        Eliminar
      </Button>
    );

    return (
      <Fragment>
        {deleteButton}
        {warningModal}
      </Fragment>
    );
  }
}

TemplateDeleteButton.propTypes = {
  itineraryId: PropTypes.number.isRequired,
  dispatchDeleteItinerarySchedule: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchDeleteItinerarySchedule: deleteItinerarySchedule,
};

export default connect(null, mapDispatchToProps)(TemplateDeleteButton);
